/* eslint-disable import/no-unresolved */

import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Render from 'components/render';
import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import PnlAnalyticsIcon from 'styles/assets/icons/PnlAnalyticsIcon';

import styles from './pnl.module.scss';

const PnlAnalyticsButton = ({
  className,
  pageName,
  showAsLink,
  showLabel,
  highlightLink = false,
}: {
  className: string | undefined;
  pageName: string;
  showAsLink?: boolean;
  showLabel?: boolean;
  highlightLink?: boolean;
}) => {
  const { t } = useTranslation(['headerFooter']);
  return (
    <Link
      to={routes.account.accountAnalytics.default}
      data-testid="pnlDashboard-link"
      className={cn(
        styles.analyticsRedirect,
        {
          [styles.analyticsRedirectButton]: !showAsLink,
          [styles.analyticsRedirectLink]: showAsLink,
        },
        className
      )}
      onClick={() => {
        trackMixpanelEvent('PNL_Analytics_Opened', {
          page_name: pageName,
        });
      }}
    >
      <Render when={!showAsLink}>
        <PnlAnalyticsIcon className={styles.pnlIcon} />{' '}
      </Render>
      <Render when={showLabel}>
        <span className={cn({ [styles.highlight]: highlightLink })}>
          {t('headerFooter:header.wallet.pnlAnalytics')}
        </span>
      </Render>
    </Link>
  );
};
export default PnlAnalyticsButton;
